import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import { Storage } from './Storage';

export const updateCookie = (loginInfo) => {
    const map = Cookies.get('X-TOKEN') ? JSON.parse(Cookies.get('X-TOKEN')) : {};

    map[loginInfo.domain] = {
        access_key: loginInfo.access_key,
        secret_key: loginInfo.secret_key,
        timestamp: loginInfo.timestamp
    };

    Cookies.set('X-TOKEN', JSON.stringify(map), {
        expires: 10,
        path: '/',
        domain: '.grtcloud.net'
    });
    if (loginInfo?.access_token) Storage.set('grtPcToken', loginInfo.access_token);
};
export const getCookie = (domain) => {
    const map = Cookies.get('X-TOKEN') ? JSON.parse(Cookies.get('X-TOKEN')) : {};

    return map[domain || window.location.host];
};

export const clearCookie = (domain) => {
    const map = Cookies.get('X-TOKEN') ? JSON.parse(Cookies.get('X-TOKEN')) : {};

    map[domain] = null;

    Cookies.set('X-TOKEN', JSON.stringify(map), {
        expires: 10,
        path: '/',
        domain: '.grtcloud.net'
    });
    localStorage.removeItem('topMenu');
    localStorage.removeItem('grtPcToken');
};
export const treeToList = (tree) => {
    let queen = [],
        out = [];
    queen = queen.concat(tree);
    while (queen.length) {
        let first = queen.shift();
        if (first.children) {
            // 下一层节点推入
            queen = queen.concat(first.children);
            delete first['children'];
        }
        out.push(first);
    }
    return out;
};
export const isMenuChecked = (curMenuItem, name) => {
    if (curMenuItem.name === name) {
        return true;
    }
    if (curMenuItem.children && curMenuItem.children.length > 0) {
        for (let i in curMenuItem.children) {
            let flag = isMenuChecked(curMenuItem.children[i]);
            if (flag) {
                return true;
            }
        }
    }

    return false;
};
export const isPC = function (req) {
    let userAgentInfo = req.headers['user-agent'],
        Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'],
        flag = true;
    for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
};

/**
 * AES加密函数
 * 使用AES算法对原始文本进行加密，采用ECB模式和Pkcs7填充
 * PKCS5Padding 在 crypto-js 中对应 Pkcs7
 * @param {string} originalText - 需要加密的原始文本
 * @param {string} key - 加密密钥，需为Base64编码格式
 * @returns {string} 加密后的密文字符串
 */
export const encryptAES = (originalText, key) => {
    if (!originalText || !key) return '';
    const encrypted = CryptoJS.AES.encrypt(originalText, CryptoJS.enc.Base64.parse(key), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
};

/**
 * AES解密函数
 * 使用AES算法对密文进行解密，采用ECB模式和Pkcs7填充
 * PKCS5Padding 在 crypto-js 中对应 Pkcs7
 * @param {string} encriptedText - 需要解密的密文
 * @param {string} key - 解密密钥，需为Base64编码格式
 * @returns {string} 解密后的原始文本
 */
export const decryptAES = (encriptedText, key) => {
    if (!encriptedText || !key) return '';
    const decrypted = CryptoJS.AES.decrypt(encriptedText, CryptoJS.enc.Base64.parse(key), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
};
